<div class="flex-row align-center justify-between py-3 px-4">
  <h5 class="fw-semi-bold">{{ 'mobile_app_popup.title' | translate }}</h5>
  <button mat-icon-button class="mat-icon-lg" type="button" (click)="close()"><mat-icon>close</mat-icon></button>
</div>

<mat-divider></mat-divider>

<mat-dialog-content>
  <div class="mobile-app-content">
    <h5 class="fw-semi-bold">
      {{ 'mobile_app_popup.heading' | translate }}
    </h5>

    <p class="body-4 fw-medium">
      {{ 'mobile_app_popup.description' | translate }}
    </p>

    <div class="app-store-badges">
      <a [href]="appStoreUrl" target="_blank" rel="noopener noreferrer" aria-label="Download iKonnect on the App Store">
        <img [src]="appStoreBadge" alt="Download on the App Store" />
      </a>

      <a [href]="googlePlayUrl" target="_blank" rel="noopener noreferrer" aria-label="Get iKonnect on Google Play">
        <img [src]="googlePlayBadge" alt="Get it on Google Play" />
      </a>
    </div>
  </div>
</mat-dialog-content>

<mat-divider></mat-divider>

<div class="popup-actions p-4">
  <button mat-stroked-button type="button" (click)="dontShowAgain()" class="lg-btn mr-3">{{ 'mobile_app_popup.dont_show_again' | translate }}</button>

  <button mat-flat-button color="primary" (click)="close()" class="lg-btn">{{ 'mobile_app_popup.continue_web' | translate }}</button>
</div>
